import { Flex, Skeleton } from "antd";

export default function TopBarLoading() {
  return (
    <Flex
      className="p-4 rounded-xl border border-theme-zinc-200"
      gap={16}
      align="center"
    >
      <Skeleton.Avatar active size={80} shape="square" />
      <div className="flex-1">
        <Skeleton.Input
          active
          size="large"
          style={{ width: 80, marginBottom: 8 }}
        />
        <Skeleton.Input active size="small" style={{ width: 120 }} />
      </div>
    </Flex>
  );
}
